module.exports = __webpack_public_path__ + "img/navbar-logo.c11202f9.png";